import '../styles/home.scss';
import ProfileLinks from '../components/ProfileLinks';

function Footer () {
    return(
        <footer className="footer">
            <h1>Let's connect!</h1>
            <ProfileLinks variant="footer" />
        </footer>
    );
};

export default Footer;